import { GetOffchainData } from './GetOffchainData';
import { GetImage } from './GetImage';
import { Reroute } from './Reroute';
import { GetOffchainDataV2 } from './GetOffchainDataV2';
import { Reflow } from './Reflow';
import { TradingGraph } from './TradingGraph';
import { GetParam } from './GetParam';
import { SetParam } from './SetParam';
import { GetPool } from './GetPool';
import { GetPercent } from './GetPercent';
import { Alert } from './Alert';
import { GetJSON } from './GetJSON';
import { ReactComponent } from './ReactComponent';
var OffchainData = {
    getters: {
        GetOffchainData: GetOffchainData,
        GetImage: GetImage,
        Reroute: Reroute,
        GetOffchainDataV2: GetOffchainDataV2,
        Reflow: Reflow,
        TradingGraph: TradingGraph,
        SetParam: SetParam,
        GetParam: GetParam,
        GetPool: GetPool,
        GetPercent: GetPercent,
        Alert: Alert,
        GetJSON: GetJSON,
        ReactComponent: ReactComponent
    },
};
export { OffchainData };
